import api from ".";

export const downloadCertificate = async (hash: string) => {
  const url = `/certificates/${hash}`;

  try {
    const response = await api.get(url, {
      responseType: "blob",
      headers: {
        Accept: "application/pdf",
      },
    });
    return response;
  } catch (error) {
    console.error("Certificado nao encontrado.", error);
  }
};
